import React, { useEffect, Component } from "react";
import { makeStyles } from '@material-ui/core/styles';
import { applyDataTable } from '../../../../components/custom/dataTable';
import $ from "jquery"
import { withStyles } from '@material-ui/core/styles';
import withRouter from "../../../custom/withRouter";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import moment from "moment";
import { gethistorylogSOC } from "../../../../actions/SOCAction";
import styles from "../../../../assets/jss/customStyle";
const useStyles = makeStyles((theme) => ({
    button: {
        background: "#FFFFFF",
        border: "none",
        boxSizing: "border-box",
        borderRadius: "7px",
        padding: "5px 10px"
    },
    fontIcon: {
        paddingRight: "8px",
    }
}));

class EditSOC_Historylog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ProjectId:0,
            isMobile: false,
            isError: false,
        }
    }
    componentDidMount() {
        const { dispatch } = this.props;
        this.state.ProjectId = localStorage.getItem("DashId")
        dispatch(gethistorylogSOC(this.state.ProjectId))
        this.interval = setInterval(() => {
            this.resize()
        }, 10);
    }
    componentWillUnmount() {
        clearInterval(this.interval);

    }
    resize = () => {
        this.setState({})
        if (window.innerWidth < 850) {
            this.setState({
                isMobile: true
            })
        }
        else {
            this.setState({
                isMobile: false
            })
        }
    };
    render() {
        
        let { classes, menuToggle} = this.props;
        return (
            <>
                <div style={{ margin: this.state.isMobile ? "0" : "5px 15px" }}>
                    <div className="row mt-1">
                        <div className="col-sm-12 col-12">
                            <div className="table-responsive" style={{ width: "100%" }}>
                                <table className="dataTable">
                                    <thead>
                                        <tr className="">
                                            <th className="border-right" width="15%"><span className="fw-bold" style={{ color: "#000000" }}>Timestamp</span></th>
                                            <th className="border-right" width="7%"><span className="fw-bold" style={{ color: "#000000" }}>Action</span></th>
                                            <th className="border-right" width="15%"><span className="fw-bold" style={{ color: "#000000" }}>Action by</span></th>
                                            <th className="" width="63%"><span className="fw-bold" style={{ color: "#000000" }}>Comments</span></th>
                                        </tr>
                                    </thead>
                                    <tbody style={{ fontFamily: 'Segoe UI' }}>
                                    {this.props.historyLog && this.props.historyLog.map((i) => (
                                        <tr>
                                            <td className="Nowrap">{moment(i.TimeStamp).format("DD-MM-YYYY HH:MM:SS A")}</td>
                                            <td className="">{i.Action}</td>
                                            <td className="">{i.ActionBy}</td>
                                            <td className="">{i.Comments}</td>
                                        </tr>
                                    ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }

}
function mapDispatchToProps(dispatch) {
    return {
        dispatch,
    };
}

function mapStateToProps(state) {
    return {
        menuToggle: state.commonReducer.menuToggle,
        historyLog: state.commonReducer.historyLog || [],
       
    };
}

EditSOC_Historylog.propTypes = {
    classes: PropTypes.object.isRequired,
}
export default withRouter(
    connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(EditSOC_Historylog))
);



